import { NgModule } from '@angular/core';

import { RtUIModule } from '@recruitee/user-interface';

import { WysiwygAdapterModule } from '../wysiwyg-extensions/adapter/wysiwyg-adapter.module';
import { WysiwygLinkComponent } from '../wysiwyg-extensions/link/wysiwyg-link.component';
import { WysiwygPlaceholderComponent } from '../wysiwyg-extensions/placeholders/wysiwyg-placeholder/wysiwyg-placeholder.component';
import { RedactorAlignmentButtonsExtension } from './extensions/alignment-buttons/alignment-buttons';
import { RedactorFontFamilyExtension } from './extensions/font-family/font-family';
import { RedactorLinkToggleExtension } from './extensions/link-toggle/link-toggle';
import { RedactorLinkExtension } from './extensions/link/link';
import { RedactorPlaceholderExtension } from './extensions/placeholder/placeholder';
import { RedactorQuoteExtension } from './extensions/quote/quote';
import { RedactorAdapterExtension } from './extensions/redactor-adapter';
import { REDACTOR_EXTENSIONS } from './extensions/redactor-extension';
import { RedactorSignatureExtension } from './extensions/signature/signature';
import { RedactorUploadExtension } from './extensions/upload/upload';
import { RedactorComponent } from './redactor.component';
import { RedactorService } from './redactor.service';

@NgModule({
  imports: [
    RtUIModule,
    WysiwygAdapterModule.provideEmbeddableComponent(WysiwygPlaceholderComponent),
    WysiwygAdapterModule.provideEmbeddableComponent(WysiwygLinkComponent),
  ],
  providers: [
    RedactorService,
    {
      provide: REDACTOR_EXTENSIONS,
      useClass: RedactorAdapterExtension,
      multi: true,
    },
    {
      provide: REDACTOR_EXTENSIONS,
      useClass: RedactorUploadExtension,
      multi: true,
    },
    {
      provide: REDACTOR_EXTENSIONS,
      useClass: RedactorQuoteExtension,
      multi: true,
    },
    {
      provide: REDACTOR_EXTENSIONS,
      useClass: RedactorPlaceholderExtension,
      multi: true,
    },
    {
      provide: REDACTOR_EXTENSIONS,
      useClass: RedactorLinkExtension,
      multi: true,
    },
    {
      provide: REDACTOR_EXTENSIONS,
      useClass: RedactorSignatureExtension,
      multi: true,
    },
    {
      provide: REDACTOR_EXTENSIONS,
      useClass: RedactorSignatureExtension,
      multi: true,
    },
    {
      provide: REDACTOR_EXTENSIONS,
      useClass: RedactorAlignmentButtonsExtension,
      multi: true,
    },
    {
      provide: REDACTOR_EXTENSIONS,
      useClass: RedactorLinkToggleExtension,
      multi: true,
    },
    {
      provide: REDACTOR_EXTENSIONS,
      useClass: RedactorFontFamilyExtension,
      multi: true,
    },
  ],
  declarations: [RedactorComponent],
  exports: [RedactorComponent],
})
export class RedactorModule {}

export * from './redactor.service';
export * from './redactor.types';
export * from './redactor.component';
export * from './extensions/redactor-extension';
export * from './extensions/placeholder/placeholder';
export * from './extensions/upload/upload';
export * from './extensions/quote/quote';
export { SIGNATURE_DEFAULT_CLASS } from './extensions/signature/signature';
